export default __webpack_public_path__ + "fc1c6aa97474a73cc2d9e3cc9c823970.png";